import { render, staticRenderFns } from "./ParametrosCertificado.vue?vue&type=template&id=a5481c40&scoped=true"
import script from "./ParametrosCertificado.vue?vue&type=script&lang=js"
export * from "./ParametrosCertificado.vue?vue&type=script&lang=js"
import style0 from "./ParametrosCertificado.vue?vue&type=style&index=0&id=a5481c40&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5481c40",
  null
  
)

export default component.exports